import axios from "axios";

export const getKybInfo = (digioId: string, sessionId: string | null) => {
  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}get/document/status`,
      {
        params: {
          doc_id: `${digioId}`,
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      }
    )
    .then((response) => {
      return response;
    })
    .catch((err) => err);
};
